import { legal } from './copy';

const Legal = () => {
  return (
    <div className="grid gap-3 mt-8">
      {legal.map((item, i) => (
        <p
          className="text-sm text-gray-400"
          key={i}
          dangerouslySetInnerHTML={{ __html: item }}
        ></p>
      ))}
    </div>
  );
};
export default Legal;
